import { EventTypeInput } from './EventTypeInput';
import { EventTypeGroup } from './EventTypeGroup';
import { DelayEvent } from './DelayEvent';
import { CaptainsDocument } from './CaptainsDocument';
import { RotationTreeEnum } from '../../enums/rotationTreeEnum';
import { EventTypeInputGroup } from './EventTypeInputGroup';
import { EventTypeInputDelayEventTypeMap } from './EventTypeInputDelayEventTypeMap';
import { EventTypeInputExcludeTimeEventTypeMap } from './EventTypeInputExcludeTimeEventTypeMap';
import { getOverriddenEventTypeName } from '../../utils/event/eventTypeNameOverrides';

export class EventType {
    constructor(
        eventTypeId: number,
        eventTypeGroupId: number,
        name: string,
        shortName: string,
        mandatory: boolean,
        showInPlanView: boolean,
        allowedInPlan: boolean,
        actualMandatory: boolean,
        ordered: boolean,
        portLog: boolean,
        statementOfFacts: boolean,
        documentTemplateUrl: string | null,
        icon: string,
        nextEventTypeInGroupId: number | null,
        eventTypeInputArray: EventTypeInput[] | null,
        shoresideInstruction: string | null,
        selectable: boolean,
        editable: boolean,
        deletable: boolean,
        eventTypeGroupRequiredArray: number[] | null,
        delayEvent: DelayEvent | null,
        captainsDocument: CaptainsDocument | null,
        concurrentEventTypeInputId: number | null,
        levelId: RotationTreeEnum,
        parentSequenceNumber: number | null,
        eventTypeInputGroupArray: EventTypeInputGroup[] | null,
        eventTypeGroupSequenceIdentity: string | null,
        eventTypeGroupSequenceDependencyIdentity: string | null,
        deleted: boolean,
        dependencyDisplayName: string | null,
        eventTypeInputDelayEventTypeMapArray: EventTypeInputDelayEventTypeMap[],
        eventTypeInputExcludeTimeEventTypeMapArray: EventTypeInputExcludeTimeEventTypeMap[],
        useInSimpleMode: boolean | null,
        onlyUseInSimpleMode: boolean | null
    ) {
        this.eventTypeId = eventTypeId;
        this.eventTypeGroupId = eventTypeGroupId;
        this.name = name;
        this.shortName = shortName;
        this.mandatory = mandatory;
        this.showInPlanView = showInPlanView;
        this.allowedInPlan = allowedInPlan;
        this.actualMandatory = actualMandatory;
        this.ordered = ordered;
        this.portLog = portLog;
        this.statementOfFacts = statementOfFacts;
        this.documentTemplateUrl = documentTemplateUrl;
        this.icon = icon;
        this.nextEventTypeInGroupId = nextEventTypeInGroupId;
        this.eventTypeInputArray = eventTypeInputArray;
        this.shoresideInstruction = shoresideInstruction;
        this.selectable = selectable;
        this.editable = editable;
        this.deletable = deletable;
        this.eventTypeGroupRequiredArray = eventTypeGroupRequiredArray;
        this.delayEvent = delayEvent;
        this.captainsDocument = captainsDocument;
        this.concurrentEventTypeInputId = concurrentEventTypeInputId;
        this.levelId = levelId;
        this.eventTypeGroup = null;
        // Use overridden name for new events (uses current date to determine if override applies)
        this.displayNameToolbox = getOverriddenEventTypeName(eventTypeId, new Date()) ?? name;
        this.dependencyDisplayName = dependencyDisplayName;
        this.parentSequenceNumber = parentSequenceNumber;
        this.eventTypeInputGroupArray = eventTypeInputGroupArray;
        this.eventTypeGroupSequenceIdentity = eventTypeGroupSequenceIdentity;
        this.eventTypeGroupSequenceDependencyIdentity = eventTypeGroupSequenceDependencyIdentity;
        this.deleted = deleted;
        this.eventTypeInputDelayEventTypeMapArray = eventTypeInputDelayEventTypeMapArray;
        this.eventTypeInputExcludeTimeEventTypeMapArray = eventTypeInputExcludeTimeEventTypeMapArray;
        this.useInSimpleMode = useInSimpleMode;
        this.onlyUseInSimpleMode = onlyUseInSimpleMode;
    }
    eventTypeId: number;
    eventTypeGroupId: number;
    name: string;
    shortName: string;
    mandatory: boolean;
    showInPlanView: boolean;
    allowedInPlan: boolean;
    actualMandatory: boolean;
    ordered: boolean;
    portLog: boolean;
    statementOfFacts: boolean;
    documentTemplateUrl: string | null;
    icon: string;
    nextEventTypeInGroupId: number | null;
    eventTypeInputArray: EventTypeInput[] | null;
    shoresideInstruction: string | null;
    selectable: boolean;
    editable: boolean;
    deletable: boolean;
    eventTypeGroupRequiredArray: number[] | null;
    delayEvent: DelayEvent | null;
    captainsDocument: CaptainsDocument | null;
    concurrentEventTypeInputId: number | null;
    levelId: RotationTreeEnum;
    eventTypeGroup: EventTypeGroup | null;
    displayNameToolbox: string;
    dependencyDisplayName: string | null;
    eventTypeInputGroupArray: EventTypeInputGroup[] | null;
    eventTypeGroupSequenceIdentity: string | null; // View model
    eventTypeGroupSequenceDependencyIdentity: string | null; // View model
    parentSequenceNumber: number | null; // View model
    deleted: boolean;
    useInSimpleMode: boolean | null;
    onlyUseInSimpleMode: boolean | null;
    eventTypeInputDelayEventTypeMapArray: EventTypeInputDelayEventTypeMap[];
    eventTypeInputExcludeTimeEventTypeMapArray: EventTypeInputExcludeTimeEventTypeMap[];
}
